import type { HttpTypes } from '@medusajs/types';

import { PaymentProviderId } from '@marxbiotech/shared-types/bff';

import { statusMap } from '@lib/util/order-status';
import { OrderLabel } from '@modules/common/components/order-label';

export type EnhancedStoreOrder = HttpTypes.StoreOrder & {
  cart: HttpTypes.StoreCart;
};

const isOrderReviewing = (order: EnhancedStoreOrder) => {
  const validPayment = order.payment_collections?.[0]?.payments?.filter(
    (payment) => payment.canceled_at === null
  )[0];
  return (
    order.status === 'pending' &&
    validPayment?.provider_id === PaymentProviderId.DEPOSIT_WITH_LOAN &&
    validPayment?.captured_at === null
  );
};

const OrderLabelStatusTransform = (status: string, orderId?: string) => {
  const { style, description } = statusMap[status];
  return (
    <span
      data-testid={orderId ? `order-status-label-${orderId}` : undefined}
    >
      <OrderLabel kind={style}>{description}</OrderLabel>
    </span>
  );
};

export const OrderStatusLabel = ({ order }: { order: EnhancedStoreOrder }) => {
  return order.status
    ? OrderLabelStatusTransform(
        isOrderReviewing(order) ? 'reviewing' : order.status,
        order.id
      )
    : '-';
};
